import { createContext, useContext } from 'react';

type TFilterableContext = {
  filter: Nullable<UsersFilter>;
  setFilter: Function;
};

export const UsersFilterableContext = createContext<TFilterableContext>(undefined!);

export const useUsersFilterable = () => useContext(UsersFilterableContext);
